export default __webpack_public_path__ + "static/media/smiley-06.a60b1769.png";